
<div mat-dialog-title>
  {{"Add"|translate}} {{"CLASSIFICATION"|translate}} - {{ (currentProject$|async)?.name }}

</div>
<div mat-dialog-content>
  @if (isLoading) {
    <div class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
  @if (errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
  }
  <form [formGroup]="classificationForm" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <mat-label>{{"Name"|translate}}</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{"PARENTITEM"|translate}}</mat-label>
      <mat-select formControlName="parentId">
        <mat-option [value]="null">{{"NOPARENT"|translate}}</mat-option>
        @for (classification of flattenedClassifications; track classification) {
          <mat-option [value]="classification.id">
            {{ getIndentedName(classification) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <!-- <mat-form-field>
    <mat-label>{{"Project"|translate}}</mat-label>
    <input matInput formControlName="projectId">

  </mat-form-field> -->
  <mat-form-field>
    <mat-label>{{"Description"|translate}}</mat-label>
    <textarea cdkTextareaAutosize="true" matInput formControlName="description">
    </textarea>
  </mat-form-field>

</form>


</div>

<div mat-dialog-actions flex-end>

  <button mat-raised-button color="primary" [disabled]="isLoading" (click)="onSubmit()">{{'Save'|translate}}</button>
  <button mat-button mat-dialog-close>{{"Cancel"|translate}}</button>
</div>
